import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { WorkspaceProvider } from "@/context/WorkspaceContext";
import { Spinner } from "@/components/kit";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import { Forgot, Login, Register, Reset } from "@/pages/AuthPages";
import Legal from "@/pages/Legal";
import Dashboard from "@/pages/Dashboard";
import Lancamentos from "@/pages/Lancamentos";
import Dividas from "@/pages/Dividas";
import Patrimonio from "@/pages/Patrimonio";
import Planejamento from "@/pages/Planejamento";
import MetasTarefas from "@/pages/MetasTarefas";
import Simuladores from "@/pages/Simuladores";
import BizModule from "@/pages/biz/BizModule";
import Mentor from "@/pages/Mentor";
import Relatorios from "@/pages/Relatorios";
import { Assinatura, Checkout } from "@/pages/Assinatura";
import Privacidade from "@/pages/Privacidade";
import Admin from "@/pages/Admin";
import Guia from "@/pages/Guia";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen justify-center"><Spinner /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
}

const Public = ({ children }) => {
  const { user } = useAuth();
  return user ? <Navigate to="/app" replace /> : children;
};

const APP_ROUTES = [
  ["", Dashboard], ["lancamentos", Lancamentos], ["dividas", Dividas], ["patrimonio", Patrimonio],
  ["planejamento", Planejamento], ["metas", MetasTarefas], ["simuladores", Simuladores], ["empresa", BizModule], ["mentor", Mentor],
  ["relatorios", Relatorios], ["assinatura", Assinatura], ["assinatura/checkout", Checkout], ["privacidade", Privacidade], ["guia", Guia],
];

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" richColors position="top-right" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Public><Login /></Public>} />
          <Route path="/cadastro" element={<Public><Register /></Public>} />
          <Route path="/recuperar-senha" element={<Forgot />} />
          <Route path="/reset-password" element={<Reset />} />
          <Route path="/termos" element={<Legal kind="termos" />} />
          <Route path="/privacidade" element={<Legal kind="privacidade" />} />
          <Route path="/app" element={<Protected><WorkspaceProvider><AppShell /></WorkspaceProvider></Protected>}>
            {APP_ROUTES.map(([p, C]) => (p ? <Route key={p} path={p} element={<C />} /> : <Route key="index" index element={<C />} />))}
            <Route path="admin" element={<Protected admin><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/app" replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
